import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { bool, string } from "prop-types";
import React from "react";
import { getBoolOption } from "util/creditBills";

const AcrtionBillTitleColumns = ({ tabOption, isFinished, showButton }) => {
    const { isEmitted, isInTenure, isToPay, isReceived } = getBoolOption(tabOption);

    return (
        <>
            {isEmitted && (
                <>
                    <GridTable.Data columnStart={1} alignX="flex-start" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.debtor" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2} alignX="center" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.holder" />
                    </GridTable.Data>
                </>
            )}
            {isReceived && (
                <>
                    <GridTable.Data columnStart={1} alignX="flex-start" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.emitter" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2} alignX="center" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.holder" />
                    </GridTable.Data>
                </>
            )}
            {isToPay && (
                <>
                    <GridTable.Data columnStart={1} alignX="flex-start" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.holder" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2} alignX="center" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.emitter" />
                    </GridTable.Data>
                </>
            )}

            {isInTenure && (
                <>
                    <GridTable.Data columnStart={1} alignX="flex-start" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.emitter" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2} alignX="center" rowStart={1} rowWidth={1}>
                        <I18n component="span" id="creditBill.table.debtor" />
                    </GridTable.Data>
                </>
            )}

            <GridTable.Data columnStart={3} alignX="center" rowStart={1} rowWidth={1}>
                <I18n component="span" id="creditBill.table.emission" />
            </GridTable.Data>
            <GridTable.Data columnStart={4} alignX="center" rowStart={1} rowWidth={1}>
                <I18n component="span" id="creditBill.table.expiration" />
            </GridTable.Data>
            <GridTable.Data columnStart={5} alignX="center" rowStart={1} rowWidth={1}>
                <I18n component="span" id="creditBill.table.amount" />
            </GridTable.Data>

            {!isFinished && (
                <GridTable.Data columnStart={6} alignX="center" rowStart={1} rowWidth={1}>
                    <I18n component="span" id="creditBill.table.state" />
                </GridTable.Data>
            )}
            {showButton && <GridTable.Data alignX="center" />}
        </>
    );
};

AcrtionBillTitleColumns.propTypes = {
    tabOption: string.isRequired,
    isFinished: bool,
    showButton: bool,
};

AcrtionBillTitleColumns.defaultProps = {
    isFinished: false,
    showButton: false,
};

export default AcrtionBillTitleColumns;
